import React from 'react';
import { Grid, Row, Col, Carousel } from '../utils/bootstrap';
import { Helmet } from 'react-helmet';
import CardLink from '../components/CardLink';
import MainImage from '../components/MainImage';
import { windowScrollTo } from '../utils/animation';

const styles = {
  findOut: {
    fontFamily: 'Playfair Display',
    fontStyle: 'italic',
    fontSize: '.9em',
    marginBottom: '1em',
    cursor: 'pointer'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  }
};

class CorporateInfo extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Premium Capital Partners | Business Financing Malaysia</title>
          <meta name="description" content="Premium Capital Partners are passionate about pioneering innovative finance solutions for Malaysian businesses." />
        </Helmet>
        <Carousel indicators={false}>
          <Carousel.Item>
            <MainImage img="/home.jpg" className="home-image">
              <h1>Business financing Malaysia</h1>
              <div />
              <h2>
                Pioneering Business Financial Solutions
                <div style={{ fontSize: '.6em', fontStyle: 'italic', color: '#5f8ebc', marginTop: '.5em' }}>
                  for Malaysia
                </div>
              </h2>
              <div style={styles.findOut} onClick={() => windowScrollTo(window.innerHeight, 300)}>
                find out how<br />
                <img src="/chevron-down.png" style={{ width: 30, marginTop: '.5em' }} alt="" />
              </div>
            </MainImage>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/premium.jpg" containerStyle={{ backgroundPosition: 'center bottom' }} />
            <Carousel.Caption onClick={() => this.props.history.push('/products/premium-financing')} style={{ cursor: 'pointer' }}>
              <h3>
                Premium Financing
              </h3>
              <p>
                Providing insurance premium funding that empowers your organisation to meet the costs of critical business insurance.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/business.jpg" containerStyle={{ backgroundPosition: 'center bottom' }} />
            <Carousel.Caption onClick={() => this.props.history.push('/products/business-financing')} style={{ cursor: 'pointer' }}>
              <h3>
                Business Financing
              </h3>
              <p>
                Innovative business financing solutions that adapt to your unique business requirements and corporate transaction needs.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        <Grid>
          <Row style={styles.row}>
            <Col md={7} xs={12}>
              <h4 style={{ marginBottom: '2em' }}>
                Premium Capital Partners are passionate about pioneering innovative finance
                solutions for Malaysian businesses. Our highly experienced team are committed to
                delivering effective financial products that meet the needs of the modern business
                landscape.
              </h4>
              <h4>What does that mean for you?</h4>
              <p>
                We provide flexible, personalised financial solutions for your business. If you need
                financing for essential business insurance, our Premium Financing model helps ensure
                you stay protected.
              </p>
              <h4>Undertaking a transformative corporate transaction?</h4>
              <p>
                Our Corporate Transaction Loans offer a flexible funding model that can adapt to
                meet your transaction needs.
              </p>
              <h4>Looking for a more traditional route towards accessing financing?</h4>
              <p>
                Our Asset-based Lending helps unlock the underlying value of your business assets to
                support funding that enables you to grow.
              </p>
            </Col>
            <Col md={5} xs={12}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '5rem'
              }}>
                <img src="/quot-white.png" style={{ margin: 'auto', width: 90, height: 'auto' }} alt="" />
                <h3 style={{
                  fontSize: '1.3em',
                  color: 'white',
                  textAlign: 'center'
                }}>
                  We are driven by a commitment to deliver financial solutions that support
                  and empower the ambitions of Malaysia's vibrant business sector.
                </h3>
              </div>
            </Col>
          </Row>
          <Row>
            <CardLink
              img="/premium.jpg"
              header="Premium Financing"
              body="Providing insurance premium funding that empowers your organisation to meet the costs of critical business insurance."
              link="/products/premium-financing"
            />
            <CardLink
              img="/business.jpg"
              header="Business Financing"
              body="Innovative business financing solutions that adapt to your unique business requirements and corporate transaction needs."
              link="/products/business-financing"
            />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default CorporateInfo;



// WEBPACK FOOTER //
// ./src/screens/Home.js